import React from 'react';
import InputMask from 'react-input-mask';
import { connect } from 'react-redux';

import { answerQuestion } from '../../../../../_actions/questionnaire.actions';

const Date = ({ question, dispatch }) => {
  return (
    <>
      <h6 className="card-title">{question.text || 'Enter your question.'}</h6>

      <InputMask
        onChange={(e) => { dispatch(answerQuestion(question, e.target.value)) }}
        className="form-control"
        type="text"
        inputMode="numeric"
        mask="99/99/9999"
      />
    </>
  );
}

export default connect()(Date);